import React from 'react';
import ReactDOM from "react-dom/client";
import './index.css';
import App from './App';
import { register as registerServiceWorker } from './serviceWorkerRegistration'; // PWA Info
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
import amplifyAuthConfig from './amplifyAuthConfig';
Amplify.configure(awsExports);
Amplify.configure(amplifyAuthConfig);



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerServiceWorker();
